import { useEffect, useState } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { message } from "antd";
import { getOnboardingByApplicant, updateOnboardingData } from "Services/AdminServices/OnBoardingService";
import { submitOnboardingData } from "Services/AdminServices/OnBoardingService";

function useOnboardingProcess() {
  const params = useParams();

  const { param1 } = useParams(); // extract only empId
  const jobApplicantIdNum = Number(param1);
  const jobApplicantId = jobApplicantIdNum;
  const navigate = useNavigate();
  const location = useLocation();
  const [isCompleted, setIsCompleted] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false); // for PUT
  const [loading, setLoading] = useState(false);

  const defaultForm = {
    jobApplicantId: null, // This will be set in useEffect
    welcomeEmail: false,
    mentorAssignment: false,
    recurringOneOnOneMeetings: false,
    firstDayMeetings: false,
    welcomeMeeting: false,
    welcomeLunch: false,
    businessIntroduction: false,
    officeTour: false,
    regularCheckIns: false,
    shadowingOpportunities: false,
    adHocSupport: false,
    benefitsEnrollment: false,
    emergencyContactInfo: false,
    employeeHandbook: false,
    directDepositInfo: false,
    employmentEligibilityForm: false,
    ndaOrNonCompete: false,
    stateTaxWithholdingForm: false,
    federalTaxWithholdingForm: false,
  };

  const [formData, setFormData] = useState(defaultForm);
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    // Debug logging to see what's happening
    console.log("jobApplicantId from params:", jobApplicantId);
    
    if (!jobApplicantId) {
      console.error("No jobApplicantId found in URL params");
      return;
    }

    const id = Number(jobApplicantId);
    if (isNaN(id)) {
      console.error("jobApplicantId is not a valid number:", jobApplicantId);
      return;
    }

    const fetchOnboarding = async () => {
      setLoading(true);
      
      try {
        const res = await getOnboardingByApplicant(id);
         console.log("response in onboarding ", res);
        if (!res?.exists) {
          setIsEditMode(false);
          // Make sure to set the jobApplicantId in the form data
          setFormData({
            ...defaultForm,
            jobApplicantId: id,
          });
        } else {
          setFormData({
            ...res.data,
            onboardingId: res.data.id,
          });
          setIsEditMode(true);
          setIsCompleted(res.isCompleted);
        }
      } catch (err) {
        console.error("Failed to fetch onboarding data:", err);
        message.error("Failed to load onboarding");
      } finally {
        setLoading(false);
      }
    };

    fetchOnboarding();
  }, [jobApplicantId]); // Only depend on jobApplicantId

  const handleCheckboxChange = (key) => {
    setFormData((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  const handleSubmit = async () => {
    try {
      let response;
      
      const payload = {
        ...formData,
        onboardingId: formData.onboardingId || formData.id,
      };
      
      if (isEditMode) {
        response = await updateOnboardingData(payload); // PUT
      } else {
        response = await submitOnboardingData(payload); // POST
      }
      
      message.success("Onboarding saved successfully");
      navigate("/onboarding");
      
      const allChecked = Object.values(formData)
        .filter(v => typeof v === "boolean")
        .every(v => v === true);
      
      if (allChecked) setIsCompleted(true);
    } catch (error) {
      console.error("Failed to save onboarding:", error);
      message.error("Failed to save onboarding");
    }
  };

  const handleNavigation = () => {
    // Make sure jobApplicantId is defined before navigating
    if (jobApplicantId) {
      navigate(`/humanResource/${jobApplicantId}`);
    } else {
      console.error("Cannot navigate: jobApplicantId is undefined");
    }
  };

  return {
    formData,
    setFormData,
    handleSubmit,
    handleNavigation,
    isCompleted,
    loading,
    handleCheckboxChange,
  };
}

export default useOnboardingProcess;